import { GetEventResponse } from '@orbit/api-types'
import { TripHelper } from '@lib/TripHelper'
import { addDays, eachDay, formatWeekday, toDashed } from '@lib/datetime'
import { TripDayInfo } from '@hooks'
import { Event, Trip } from '@types'
import { Day, Itinerary } from './types'

/**
 * Calculates the actual date from trip start date and tripDayIndex
 * @param backendEvent - Event from the backend API
 * @param trip - Trip object containing startDate
 * @returns Date string in YYYY-MM-DD format
 */
export const calculateEventDate = (backendEvent: Event, trip: Trip): string => {
	const tripHelper = new TripHelper(trip)
	return tripHelper.calculateDateFromDayIndex(backendEvent.tripDayIndex)
}

export const generateItinerary = (tripData: Trip, events?: GetEventResponse[], tripDayInfos?: TripDayInfo[]): Itinerary | null => {
	const tripHelper = new TripHelper(tripData)

	if (!tripHelper.hasValidDates()) {
		console.warn('Trip data missing startDate or dayCount')
		return null
	}

	const startDashed = toDashed(tripData.startDate)
	const endDashed = addDays(tripData.startDate, tripData.dayCount - 1)

	const days: Day[] = eachDay(startDashed, endDashed).map((date, dayIndex) => {
		// Filter and sort events for this day
		const dayEvents =
			events
				?.filter(event => event.tripDayIndex === dayIndex)
				.sort((a, b) => a.eventIndex - b.eventIndex) || []

		const dayInfo = tripDayInfos?.find(info => info.dayIndex === dayIndex)

		return {
			id: dayIndex.toString(),
			date,
			displayName: formatWeekday(date, 'long'),
			events: dayEvents,
			name: dayInfo?.name ?? null,
			note: dayInfo?.note ?? null,
		}
	})

	const newItinerary: Itinerary = {
		id: `itinerary-${Date.now()}`,
		title: `${tripData.name} Itinerary`,
		startDate: startDashed,
		endDate: endDashed,
		days,
	}

	return newItinerary
}
